import { createContext } from 'react';

// true = loader is done/hidden (default true so components rendered
// outside the provider still animate)
export const LoadingContext = createContext(true);
